import _ from 'lodash'
import {backendSingularKind} from '../record_building/record_keys'

export const getParams = (kind, params) => {
	return {[backendSingularKind(kind)]: params}
}

export const afterIndex = ({scopeId, items = []}) => {
	if (!items || !_.isArray(items)) return []
	items = items.map(i => ({
		...i,
		scopeIds: _.uniq([...(i.scopeIds || []), scopeId]),
		skipFetchStamp: false,
	}))
	return items
}
